export default __webpack_public_path__ + "static/media/nerede_1.13012c92.JPG";